export enum AlertTypes {
	SUCCESS = 'success',
	INFO = 'info',
	WARNING = 'warning',
	DANGER = 'danger',
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
}
